import React, { Component } from 'react';
import { Link } from 'gatsby';

import { GetCategory } from 'query';
import { classnames, classname } from 'utils';

import './Categories.css';

/**
 * Список категорий
 */
class Categories extends Component {
  cl = classname('categories');

  render() {
    const { className, data } = this.props;

    const classes = classnames(className, this.cl());

    return (
      <ul className={classes}>
        {data.map(({ title, uri }, index) => (
          <Link className={this.cl('item', { page: Math.floor(index / 4 + 1) })} key={title} to={uri}>
            {title}
          </Link>
        ))}
      </ul>
    );
  }
}

export default props => <GetCategory>{data => <Categories data={data} {...props} />}</GetCategory>;
